import type { EnrichedRecommendationLocation } from '@/api/enrichedRecommendation';
import Location from '@/models/location';
import { getPlaceCategoryDisplay } from '@/utils/placeCategoryDisplay';
import { determineSlotType } from '@/utils/slotTypeDeterminer';
import { getPlaceSearchResultSubtitle } from '@/utils/placeSearchResultSubtitle';
import { getFirstPhotoUrl } from '@/utils/photoUtils';
import { DEFAULT_POST_IMAGE } from '@/constants/common';

export function enrichedLocationToLocation(
  loc: EnrichedRecommendationLocation | null | undefined,
): Location | null {
  if (!loc?._id) return null;
  return new Location({
    _id: loc._id,
    name: loc.name,
    google_place_id: loc.google_place_id,
    a3_intl_address: loc.a3_intl_address,
    address: loc.address,
    gt_category: loc.gt_category,
    category_name: loc.category_name,
    google_types: loc.google_types,
    main_photo: loc.main_photo,
    photos: loc.photos,
    google_places_data: loc.google_places_data,
  });
}

/** Figma-style category chip: HOTEL, RESTAURANT, LANDMARK, EXPERIENCE, etc. */
export function getCreateLinkCategoryLabel(
  place: Pick<
    EnrichedRecommendationLocation,
    'gt_category' | 'category_name' | 'google_types'
  >,
): string | null {
  const display = getPlaceCategoryDisplay(place);
  if (display) {
    const upper = display.label.toUpperCase();
    if (upper === 'STAY') return 'HOTEL';
    if (upper === 'FOOD' || upper === 'EAT') return 'RESTAURANT';
    if (upper === 'CULTURE' || upper === 'NATURE') return 'LANDMARK';
    if (upper === 'DO') return 'EXPERIENCE';
    return upper;
  }

  const slot = determineSlotType(place as Location);
  if (slot === 'stay') return 'HOTEL';
  if (slot === 'eat') return 'RESTAURANT';
  if (slot === 'flight') return 'LANDMARK';
  return 'EXPERIENCE';
}

export function getCreateLinkPlacePhoto(location: Location): string {
  return (
    location.main_photo ||
    getFirstPhotoUrl(
      {
        photos: location.photos,
        google_places_data: location.google_places_data,
      },
      400,
    ) ||
    location.thumbnailPhotoURI ||
    DEFAULT_POST_IMAGE
  );
}

export function getCreateLinkPlaceCity(location: Location): string {
  return getPlaceSearchResultSubtitle(location);
}
